import { http } from '@/services/http_service';
export default{
    updateSettings(context,data)
    {
        return http()
        .post("/sets/update",data)
        .then((response) => {         
            //console.log('설정업데이트',response);            
            context.commit('setValue', response.data.userset)
           
            return response.data;
        },function(error){
            console.log(error.response.data);
            return error.response.data;
        });     
    },  
    
}